<template>
  <b-modal
    id="video-saved"
    ref="video-saved"
    size="xl"
    modal-class="mc-modal mc-modal--video-saved"
    title="Video Tersimpan"
    centered
    @hide="cancelModal"
    @show="openModal"
  >
    <b-row class="mc-list-info__top mb-2">
      <b-col>
        <span>{{ $t('videoHistory.video.numberPlate') }}</span>
        <strong>{{ videoData?.vehicle.licensePlate ?? '-' }}</strong>
      </b-col>
      <b-col>
        <span>{{ $t('trackVideo.camera') }}</span>
        <strong>{{ videoData?.calculatedChannel ?? '-' }}</strong>
      </b-col>
      <b-col>
        <span>{{ $t('videoHistory.downloadDate') }}</span>
        <strong>{{ videoData?.downloadOn ?? '-' }}</strong>
      </b-col>
      <b-col>
        <span>{{ $t('setting.homePage.pengguna') }}</span>
        <strong>{{ videoData?.users?.fullname ?? '-' }}</strong>
      </b-col>
    </b-row>
    <div
      class="mc-modal-video__Wrapper"
      :class="{
        'mc-modal-video--liveview-full': isFullscreen,
        'mc-modal-video--liveview': !isFullscreen,
      }"
    >
      <div
        class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open modal-download-video-histories"
      >
        <div class="mc-trackvideo-list__item-video-content-open-source">
          <VideoPlayer
            v-if="getFormatVideo === 'mp4' || getFormatVideo === 'MP4'"
            ref="videoInPlayerNotif"
            class="vjs-custom-skin"
            :options="playerInOptions"
            @ready="onInPlayerReady($event)"
            @error="onInPlayerError($event)"
            @waiting="onInPlayerWaiting($event)"
            @loadeddata="onInPlayerLoadedData($event)"
            @ended="onInPlayerEnded($event)"
          />
          <video-player-mux
            v-else-if="getFormatVideo === 'ts'"
            ref="videoInPlayerNotif"
            class="vjs-custom-skin"
            :src="videoData.videoUrl"
            :playerId="`videoPlayer${videoData.id}`"
            @ready="onInPlayerReady($event)"
            @error="onInPlayerError($event)"
            @waiting="onInPlayerWaiting($event)"
            @loadeddata="onInPlayerLoadedData($event)"
            @ended="onInPlayerEnded($event)"
          />
        </div>
        <div class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action">
          <div>
            <span>
              <i v-if="!isPlay" class="mc-fa icon-outline_play-circle" @click="playVideo" />
              <i v-else class="mc-fa icon-outline_pause-circle" @click="pauseVideo" />
            </span>
          </div>
          <div>
            <span>
              <i v-if="!isMuted" class="mc-fa icon-outline_volume-up" @click="muteVideo" />
              <i v-else class="mc-fa icon-outline_volume-off" @click="unmuteVideo" />
            </span>
            <i v-if="!isFullscreen" class="mc-fa icon-outline_expand" @click="startFullscreen" />
            <i v-else class="mc-fa icon-outline_collapse" @click="exitFullscreen" />
          </div>
        </div>
      </div>

      <!-- <NoFeedBack />
        <Connecting />
        <NoVideo /> -->
      <!-- </div> -->
    </div>
    <template #modal-footer>
      <div class="mc-modal__filter-footer">
        <div class="d-flex flex-row-reverse">
          <div>
            <b-button variant="outline-primary" class="me-2" @click="cancelModal()">{{
              $t('global.action.cancel')
            }}</b-button>
            <McButton
              size="md"
              :text="loadingDownload ? $t('global.processing') : $t('global.action.download')"
              :loading="loadingDownload"
              :icon="loadingDownload ? undefined : 'icon-outline_download'"
              @click="$emit('clickDownload', videoData)"
            />
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import VideoPlayerMux from '@/components/Video/VideoPlayerMux.vue'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  name: 'VideoHistoryPlayer',
  components: {
    VideoPlayer,
    VideoPlayerMux,
    McButton,
  },
  mixins: [MixPanel, Helper],
  props: {
    videoData: {
      type: Object,
    },
    loadingDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPlay: true,
      isMuted: false,
      isFullscreen: false,
      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],

        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
    }
  },
  computed: {
    getFormatVideo() {
      if (this.videoData?.videoUrl) {
        const arrUrl = this.videoData.videoUrl.split('?')
        const arrFormat = arrUrl[0].split('.')
        const format = arrFormat[arrFormat.length - 1]
        return format
      } else {
        return 'mp4'
      }
    },
  },
  watch: {
    videoData(videoData) {
      if (videoData) {
        this.setVideoPlayerOptions(videoData)
      }
    },
  },
  methods: {
    playVideo() {
      this.isPlay = true
      this.$refs['videoInPlayerNotif'].player.play()
    },
    pauseVideo() {
      this.isPlay = false
      this.$refs['videoInPlayerNotif'].player.pause()
    },
    muteVideo() {
      this.isMuted = true
      this.$refs['videoInPlayerNotif'].player.muted(true)
    },
    unmuteVideo() {
      this.isMuted = false
      this.$refs['videoInPlayerNotif'].player.muted(false)
    },
    startFullscreen() {
      this.isFullscreen = true
      let elem = document.documentElement
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },
    exitFullscreen() {
      this.isFullscreen = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },
    downloadVideo() {
      this.track('Click Video History Download', {
        license_plate: this.videoData.vehicle.licensePlate,
        filename: `${this.videoData.mediaFilename}`,
      })
      if (this.videoData.videoUrl) {
        const link = document.createElement('a')
        link.href = this.videoData.videoUrl
        link.setAttribute('download', `${this.videoData.mediaFilename}`)
        link.click()
        link.remove()
      }
    },
    setVideoPlayerOptions(video) {
      this.playerInOptions.sources[0].src = video.videoUrl
    },
    cancelModal() {
      this.playerInOptions.sources[0].src = ''
      this.$emit('resetVideoData')
      this.$bvModal.hide('video-saved')
    },
    onInPlayerReady() {
      this.$refs['videoInPlayerNotif'].player.play()
      this.$refs['videoInPlayerNotif'].player.on('ended', (event) => {
        this.isPlay = false
      })
    },

    onInPlayerError(e) {
      // eslint-disable-next-line no-console
      console.log(e)
    },

    onInPlayerWaiting() {
      setTimeout(() => {
        this.$refs['videoInPlayerNotif'].player.pause()
      }, 20 * 1000)
    },

    onInPlayerLoadedData(e) {
      // eslint-disable-next-line no-console
      console.log(e)
    },

    onInPlayerEnded() {
      this.$refs['videoInPlayerNotif'].player.pause()
      this.isPlay = false
    },

    openModal() {
      this.isPlay = true
      this.isMuted = false
      this.isFullscreen = false
    },
  },
}
</script>
